import styled from "styled-components";

export const Container = styled.span`
  font-size: 46px;
`;
